import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio"];
import React from 'react';

var Copy = function Copy(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: preserveAspectRatio
  }, unhandledProps, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.07,21.47H4V7H5.52V4.89H3.58a1.7,1.7,0,0,0-1.7,1.7V21.9a1.7,1.7,0,0,0,1.7,1.7H14.46a1.7,1.7,0,0,0,1.7-1.7h0v-.45H14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.82,3.6,18.93.71a1,1,0,0,0-.7-.29H9.53a1.7,1.7,0,0,0-1.69,1.7V17.43a1.7,1.7,0,0,0,1.69,1.7H20.42a1.7,1.7,0,0,0,1.69-1.7h0V4.31A1,1,0,0,0,21.82,3.6ZM19.89,16.81H10.06V2.74H16.9V4.56a1.17,1.17,0,0,0,1.17,1.17h1.82V16.82Z"
  }))));
};

Copy.displayName = 'Copy';
export default Copy;